import moment from "moment";
import { FormattedMessage } from "react-intl";
import { nFormatter } from "../services/public_functions";
import { Empty, Tooltip } from "antd";

const EcoCalendarTable = (props) => {
  const {
    tableData,
    timezone,
    nextEventTime,
    isCRM,
    toggleRegisterModal,
    toggleChartsModal,
  } = props;
  return (
    <div
      id="economic-calendar-table"
      className="col-lg-10 table_container px-0"
    >
      <div className="tab-content pb-0">
        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive tableFixHead">
              <table className="table stripe display mb-0">
                <thead>
                  <tr>
                    <th className="text-left pl_sm">
                      <FormattedMessage id="commons.date" />
                    </th>
                    <th className="text-center">
                      <FormattedMessage id="commons.time_left" />
                    </th>
                    <th></th>
                    <th className="text-left">
                      <FormattedMessage id="commons.event" />
                    </th>
                    <th className="text-center">
                      <FormattedMessage id="commons.importance" />
                    </th>
                    <th className="text-center">
                      <FormattedMessage id="commons.previous" />
                    </th>
                    <th className="text-center">
                      <FormattedMessage id="commons.forecast" />
                    </th>
                    <th className="text-center">
                      <FormattedMessage id="commons.actual" />
                    </th>
                    <th className="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(tableData).length > 0 ? (
                    Object.keys(tableData).map((objDate) => (
                      <>
                        <tr className="bg-light" key={objDate}>
                          <th colSpan="9" className="all text-center">
                            {moment(new Date(objDate)).format(
                              "dddd, MMM DD, YYYY"
                            )}
                          </th>
                        </tr>
                        {tableData[objDate].map((event, i) => {
                          let eventTime = new Date(event.eventTime);
                          let currentTime = new Date();
                          let isPlottable = event.isPlottable;

                          // console.log('%cCompare Time', 'color: red')

                          let isPastEvent = eventTime < currentTime;

                          // let timeLeft = timeDiffCalc(eventTime, currentTime)

                          let timezoneInMin = Number(-timezone) * 60;

                          let formattedDateTime = moment(eventTime)
                            .utcOffset(timezoneInMin)
                            .format("MMM DD, HH:mm");

                          // let isTodayEvent =
                          //   moment(eventTime)
                          //     .utcOffset(timezoneInMin)
                          //     .format("YYYY-MM-DD") ===
                          //   moment()
                          //     .utcOffset(timezoneInMin)
                          //     .format("YYYY-MM-DD");

                          let unit = event.unit === "%" ? event.unit : "";
                          let actual =
                            event.actual !== null ? event.actual : "";
                          let previous =
                            event.previous !== null ? event.previous : "";
                          let revised =
                            event.revised !== null ? event.revised : "";
                          let forecast =
                            event.forecast !== null ? event.forecast : "";

                          let actualDiff = 0;
                          let previousDiff = 0;

                          let actualDiffText = "";
                          let previousDiffText = "";

                          if (actual && forecast) {
                            actualDiff = actual - forecast;
                            actualDiffText =
                              actualDiff > 0
                                ? `+${nFormatter(actualDiff, unit)}`
                                : actualDiff < 0
                                ? `${nFormatter(actualDiff, unit)}`
                                : "";
                          }

                          if (revised) {
                            previousDiff = previous - revised;
                            previousDiffText =
                              previousDiff > 0
                                ? `+${nFormatter(previousDiff, unit)}`
                                : previousDiff < 0
                                ? `${nFormatter(previousDiff, unit)}`
                                : "";
                          }

                          return (
                            <tr
                              className={`tableRow ${
                                event.eventTime === nextEventTime
                                  ? "next_event"
                                  : ""
                              } ${isPastEvent ? "faded" : ""}`}
                              key={event.id}
                            >
                              <td className="pl_sm">
                                {/* ORI: {event.eventTime} */}
                                {/* <br /> */}
                                {/* MAS:{" "} */}
                                {/* {moment(event.eventTime).format(
                            "MMM DD, HH:mm"
                          )} */}
                                {/* <br /> */}
                                {formattedDateTime}
                              </td>
                              <td className="text-center">
                                {isPastEvent ? (
                                  <i className="fa fa-check text-success"></i>
                                ) : (
                                  // (
                                  //   setInterval(
                                  //     () => {
                                  //       let x = getTimeLeft(eventTime)
                                  //       return 'test'
                                  //     },
                                  //     1000
                                  //   )
                                  // )
                                  // event.timeLeft ? event.timeLeft : '-'
                                  <span>
                                    {moment(event.eventTime).fromNow()}
                                  </span>
                                )}
                              </td>
                              <td>
                                <img
                                  src={event.flag}
                                  alt={event.regionCode}
                                  className="flagImg mr-1"
                                />
                                {event.regionCode}
                              </td>
                              <td className="event_title">
                                {event.eventTitle}
                              </td>
                              <td className="">
                                <div
                                  className={`importance importance_${event.importance}`}
                                >
                                  {event.importance}
                                </div>
                              </td>
                              <td
                                className={`text-center ${
                                  previousDiff < 0
                                    ? "revised_higher"
                                    : previousDiff > 0
                                    ? "revised_lower"
                                    : ""
                                }`}
                              >
                                <Tooltip
                                  placement="top"
                                  title={`Revised from a previous value of ${nFormatter(
                                    revised,
                                    unit
                                  )}${unit} (${previousDiffText}${unit})`}
                                  overlayClassName={
                                    previousDiffText ? "" : "d-none"
                                  }
                                >
                                  {previous && nFormatter(previous, unit)}
                                  {previous ? unit : ""}
                                </Tooltip>
                              </td>
                              <td className="text-center">
                                {forecast && nFormatter(forecast, unit)}
                                {forecast ? unit : ""}
                              </td>
                              <td
                                className={`text-center ${
                                  actualDiff > 0
                                    ? "revised_higher"
                                    : actualDiff < 0
                                    ? "revised_lower"
                                    : ""
                                }`}
                              >
                                <Tooltip
                                  placement="top"
                                  title={`A ${
                                    actualDiff > 0 ? "better" : "worse"
                                  } than expected result (${actualDiffText}${unit})`}
                                  overlayClassName={
                                    actualDiffText ? "" : "d-none"
                                  }
                                >
                                  {actual && nFormatter(actual, unit)}
                                  {actual ? unit : ""}
                                </Tooltip>
                              </td>
                              <td className="text-end">
                                {!isPastEvent && (
                                  <Tooltip placement="top" title="Notification">
                                    <i
                                      className="action_icon fas fa-bell"
                                      onClick={
                                        !isCRM ? toggleRegisterModal : undefined
                                      }
                                    />
                                  </Tooltip>
                                )}
                                <Tooltip
                                  placement="top"
                                  title={
                                    isPlottable ? (
                                      <FormattedMessage id="modal.event_chart" />
                                    ) : (
                                      ""
                                    )
                                  }
                                >
                                  <i
                                    className={`action_icon fas fa-chart-bar ${
                                      isPlottable ? "enabled" : "disabled"
                                    }`}
                                    onClick={
                                      !isCRM
                                        ? toggleRegisterModal
                                        : isPlottable
                                        ? () => toggleChartsModal(event, "1")
                                        : null
                                    }
                                  />
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={
                                    <FormattedMessage id="modal.price_chart" />
                                  }
                                >
                                  <i
                                    className="action_icon fas fa-chart-area"
                                    onClick={
                                      !isCRM
                                        ? toggleRegisterModal
                                        : () => toggleChartsModal(event, "2")
                                    }
                                  />
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={
                                    <FormattedMessage id="modal.volatility" />
                                  }
                                >
                                  <i
                                    className="action_icon fas fa-chart-line"
                                    onClick={
                                      !isCRM
                                        ? toggleRegisterModal
                                        : () => toggleChartsModal(event, "3")
                                    }
                                  />
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={<FormattedMessage id="modal.impact" />}
                                >
                                  <i
                                    className="action_icon fas fa-exchange-alt rotate_90"
                                    onClick={
                                      !isCRM
                                        ? toggleRegisterModal
                                        : () => toggleChartsModal(event, "4")
                                    }
                                  />
                                </Tooltip>
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">
                        <Empty
                          className="mt-5"
                          description={
                            <div className="emptyText">
                              <span>
                                <FormattedMessage id="emptyTable.para_1" />
                              </span>
                              <br />
                              <span>
                                <FormattedMessage id="emptyTable.para_2" />
                              </span>
                            </div>
                          }
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EcoCalendarTable;
